import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'

const InfoText = (props) => (
  <div className={classNames({
    'info-text': true,
    [props.className]:props.className 
  })}>
    { props.hasIcon ? <Icon name={ props.iconName }/> : null }
    <div className='info'>
      {props.children}
    </div>        
	</div>
)

InfoText.propTypes = {
  hasIcon: PropTypes.bool,
  iconName: PropTypes.string
}

InfoText.defaultProps = {
  iconName: 'clock',
  hasIcon: true
}

export default InfoText


// WEBPACK FOOTER //
// ./src/ui/texts/info-text.js